/* eslint-disable */
console.log("we're running react now!");
import React from 'react';
import ReactDOM from 'react-dom'; // const { render } = wp.element;
// import { BrowserRouter, Route, Switch } from 'react-router-dom';

import ActivationKitSearch from './react/components/ActivationKitSearch';
import ExhibitionSearch from './react/components/ExhibitionSearch'; // Inject ActivationKitSearch on Activation Kit Landing

var reactActivationKitSearch = document.getElementById('react-activation-kit-search');
var reactExhibitionSearch = document.getElementById('react-exhibition-search');

if (reactActivationKitSearch) {
  ReactDOM.render( /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(ActivationKitSearch, null)), reactActivationKitSearch);
} else if (reactExhibitionSearch) {
  // Inject ExhibitionSearch on Exhibition Landing Page
  ReactDOM.render( /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(ExhibitionSearch, null)), reactExhibitionSearch);
}


// WEBPACK FOOTER //
// ./scripts/react.js